// extracted by mini-css-extract-plugin
var _1 = "DocFlowUploadingTypeCell-moduleDocFlowUploadingTypeCell___nD8c";
var _2 = "DocFlowUploadingTypeCell-moduleeditButton__y21WV TableCellEditButton-moduleedit__YZdJ_";
var _3 = "DocFlowUploadingTypeCell-moduleoverlimit__dFg6G";
export { _1 as "DocFlowUploadingTypeCell", _2 as "editButton", _3 as "overlimit" }
